const KEY = "veya_bag_v1";
const INTENT_KEY = "veya_bag_intent_events_v1";

export const BAG_CHANGED_EVENT = "veya:bag_changed";

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]") || [];
  } catch {
    return [];
  }
}

function write(list) {
  localStorage.setItem(KEY, JSON.stringify(list || []));
  window.dispatchEvent(new Event(BAG_CHANGED_EVENT));
}

function readIntentEvents() {
  try {
    return JSON.parse(localStorage.getItem(INTENT_KEY) || "[]") || [];
  } catch {
    return [];
  }
}

function writeIntentEvents(list) {
  localStorage.setItem(INTENT_KEY, JSON.stringify(list || []));
}

function trackBagIntent(item, action = "add") {
  if (!item?.id) return;

  const events = readIntentEvents();

  events.unshift({
    action,
    productId: item.id,
    merchantName: item.brand || null,
    productName: item.name || null,
    category: item.category || null,
    variant: item.variant || null,
    productUrl: item.productUrl || null,
    image: item.image || null,
    occurredAt: Date.now(),
  });

  // keep this bounded
  writeIntentEvents(events.slice(0, 1000));
}

export function listBagItems() {
  return read();
}

export function getBagCount() {
  return read().length;
}

export function isInBag(productId) {
  return read().some((x) => x?.productId === productId);
}

export function addToBag(item) {
  if (!item?.id) return;

  const list = read();
  if (list.some((x) => x?.productId === item.id)) return;

  const row = {
    productId: item.id,
    createdAt: Date.now(),

    // shopper-facing bag data
    item: {
      ...item,
      addedToBagAt: Date.now(),

      // preserve future V2 handoff fields if/when present on product
      merchantName: item.brand || null,
      merchantLocation: item.location || null,
      merchantDomain: item.merchantDomain || null,
      cartHandoffStrategy: item.cartHandoffStrategy || "product_page_fallback",
      externalProductId: item.externalProductId || null,
      externalVariantId: item.externalVariantId || null,
    },
  };

  list.unshift(row);
  write(list);
  trackBagIntent(item, "add");
}

export function removeFromBag(productId) {
  const current = read();
  const row = current.find((x) => x?.productId === productId);

  if (row?.item) {
    trackBagIntent(row.item, "remove");
  }

  write(current.filter((x) => x?.productId !== productId));
}

export function clearBag() {
  write([]);
}

export function listBagIntentEvents() {
  return readIntentEvents();
}

export function groupBagItemsByMerchant() {
  const items = read();

  const map = new Map();

  for (const row of items) {
    const item = row?.item || null;
    if (!item) continue;

    const merchantName = (item.brand || "Unknown boutique").trim();

    if (!map.has(merchantName)) {
      map.set(merchantName, {
        merchantName,
        merchantLocation: item.location || null,
        cartHandoffStrategy: item.cartHandoffStrategy || "product_page_fallback",
        merchantDomain: item.merchantDomain || null,
        items: [],
      });
    }

    map.get(merchantName).items.push(item);
  }

  return Array.from(map.values()).sort((a, b) =>
    a.merchantName.localeCompare(b.merchantName)
  );
}

export function buildMerchantCartUrl(group) {
  if (!group?.items?.length) return null;

  const strategy = group.cartHandoffStrategy || "product_page_fallback";
  const first = group.items[0];

  if (strategy === "shopify_permalink" && first?.merchantDomain) {
    const parts = group.items
      .filter((item) => item.externalVariantId)
      .map((item) => `${item.externalVariantId}:1`);

    if (!parts.length) return null;

    return `https://${first.merchantDomain}/cart/${parts.join(",")}`;
  }

  if (strategy === "woocommerce_url" && group.items.length === 1 && first?.productUrl) {
    return first.productUrl;
  }

  return null;
}